import { render, staticRenderFns } from "./wine-collector.vue?vue&type=template&id=1d2e7a43&scoped=true"
import script from "./wine-collector.vue?vue&type=script&lang=js"
export * from "./wine-collector.vue?vue&type=script&lang=js"
import style0 from "./wine-collector.vue?vue&type=style&index=0&id=1d2e7a43&prod&scoped=true&lang=css"
import style1 from "./wine-collector.vue?vue&type=style&index=1&id=1d2e7a43&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e7a43",
  null
  
)

export default component.exports